const DEFAULT_SITE_URL = 'https://whatgrassisthis.com'

export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL || DEFAULT_SITE_URL

export const BRAND_ASSET_PATHS = {
  iconDefault: '/brand/icon-default.png',
  iconDark: '/brand/icon-dark.png',
  iconClearLight: '/brand/icon-clear-light.png',
  iconClearDark: '/brand/icon-clear-dark.png',
  iconTintedLight: '/brand/icon-tinted-light.png',
  iconTintedDark: '/brand/icon-tinted-dark.png',
  /** 512px transparent grass mark for in-page watermarks (the 1024 source is 1.9 MB). */
  iconHero512: '/brand/icon-hero-512.png',
  logoLockup: '/brand/logo-lockup.png',
  logoLockupInverse: '/brand/logo-lockup-inverse.png',
  favicon16: '/favicon-16x16.png',
  favicon32: '/favicon-32x32.png',
  favicon96: '/favicon-96x96.png',
  appleTouchIcon: '/apple-touch-icon.png',
  androidChrome192: '/android-chrome-192x192.png',
  androidChrome512: '/android-chrome-512x512.png',
  webManifest192: '/web-app-manifest-192x192.png',
  webManifest512: '/web-app-manifest-512x512.png',
  legacyLogo: '/whatgrassisthislogo.png',
  legacyLogoRemoveBg: '/whatgrassisthislogo-removebg-preview.png',
  legacyLogoOriginal: '/whatgrassisthislogo-original.png',
  openGraph: '/og-image-v4.jpg',
} as const

export type BrandAssetPath = typeof BRAND_ASSET_PATHS[keyof typeof BRAND_ASSET_PATHS]

export function absoluteBrandAssetUrl(
  path: BrandAssetPath | string,
  siteUrl = SITE_URL,
): string {
  return new URL(path, siteUrl).toString()
}

export const BRAND_ICON_VARIANTS = [
  {
    id: 'default',
    label: 'Default',
    path: BRAND_ASSET_PATHS.iconDefault,
  },
  {
    id: 'dark',
    label: 'Dark',
    path: BRAND_ASSET_PATHS.iconDark,
  },
  {
    id: 'clear-light',
    label: 'Clear Light',
    path: BRAND_ASSET_PATHS.iconClearLight,
  },
  {
    id: 'clear-dark',
    label: 'Clear Dark',
    path: BRAND_ASSET_PATHS.iconClearDark,
  },
  {
    id: 'tinted-light',
    label: 'Tinted Light',
    path: BRAND_ASSET_PATHS.iconTintedLight,
  },
  {
    id: 'tinted-dark',
    label: 'Tinted Dark',
    path: BRAND_ASSET_PATHS.iconTintedDark,
  },
] as const

export const BRAND_LOGO_ASSETS = [
  {
    id: 'lockup',
    label: 'Primary Lockup',
    path: BRAND_ASSET_PATHS.logoLockup,
  },
  {
    id: 'lockup-inverse',
    label: 'Inverse Lockup',
    path: BRAND_ASSET_PATHS.logoLockupInverse,
  },
] as const
